module.exports = __webpack_public_path__ + "static/card-grants-opportunities-2-4e386f571f4bbd6ff3222e9239839820.jpg";